export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const pn = editor.Panels;
    return $(`<div id="${pfx}pn-left" class="${pfx}pn-float ${pfx}one-bg" style="position:fixed;transition:none;"><div class="drag-trigger" style="position:absolute;top:0;left:0;width:100%;height:8px;border-radius:5px 5px 0px 0px;background-color:#936a9b;cursor:move;z-index:5;"></div></div>`)
        .append([pn.getPanel('views').view.$el, pn.getPanel('views-container').view.$el]);
}